import { render } from "./MilkCrateReturn.vue?vue&type=template&id=f0077504&scoped=true"
import script from "./MilkCrateReturn.vue?vue&type=script&lang=js"
export * from "./MilkCrateReturn.vue?vue&type=script&lang=js"

import "./MilkCrateReturn.vue?vue&type=style&index=0&id=f0077504&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0077504"]])

export default __exports__